"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ReactElementUtils = require("../../../utils/ReactElementUtils");

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var styleKeys = ['flexGrow', 'flexShrink', 'alignSelf'];
/**
 * The FlexItem component provides granular control for items inside the FlexLayout component or any
 * flex container. For more details, check out this comprehensive guide to Flexbox: https://css-tricks.com/snippets/css/a-guide-to-flexbox/
 */

var FlexItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FlexItem, _React$Component);

  function FlexItem() {
    _classCallCheck(this, FlexItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(FlexItem).apply(this, arguments));
  }

  _createClass(FlexItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          htmlTag = _this$props.htmlTag,
          flexGrow = _this$props.flexGrow,
          flexShrink = _this$props.flexShrink,
          alignSelf = _this$props.alignSelf,
          props = _objectWithoutProperties(_this$props, ["className", "htmlTag", "flexGrow", "flexShrink", "alignSelf"]);

      var styleProps = (0, _ReactElementUtils.getStyleProps)(styleKeys, this.props);
      return _react.default.createElement(htmlTag, _objectSpread({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-flex-item ").concat(_ThemeManager.default.getVar('classPrefix')))
      }, styleProps, {}, props));
    }
  }]);

  return FlexItem;
}(_react.default.Component);

exports.default = FlexItem;
FlexItem.defaultProps = {
  htmlTag: 'div'
};
FlexItem.propTypes = {
  /**
   * Additional custom class name.
   */
  className: _propTypes.default.string,

  /**
   * Allows the item to stretch in additional unit space if available. (0 is default)
   *
   * Detailed explanation:
   * https://css-tricks.com/snippets/css/a-guide-to-flexbox/#article-header-id-10
   */
  flexGrow: _propTypes.default.oneOf(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']),

  /**
   * Defines if the item should shrink if necessary (1 is default)
   *
   * Detailed explanation:
   * https://css-tricks.com/snippets/css/a-guide-to-flexbox/#article-header-id-11
   */
  flexShrink: _propTypes.default.oneOf(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']),

  /**
   * Allows the item to override the default alignment set by the flex container.
   *
   * Detailed explanation:
   * https://css-tricks.com/snippets/css/a-guide-to-flexbox/#article-header-id-14
   */
  alignSelf: _propTypes.default.oneOf(['auto', 'flex-start', 'flex-end', 'center', 'baseline', 'stretch']),

  /**
   * Children content.
   */
  children: _propTypes.default.node,

  /**
   * By default the root element is a 'div', but this can be any valid
   * html dom tag.  Example: 'label', 'span', 'ul', etc.
   */
  htmlTag: _propTypes.default.string
};